import AuthService from "../login/auth.service";
import { tarjetas, dimo } from "../../components/generico/utils/UrlAPI";
import axios from "axios";
import { comprobantes } from "../../components/generico/utils/UrlAPI";
import { Buffer } from "buffer";

class TarjetaService {

  async resumenTarjetas() {

    var config = {
      method: "get",
      url: tarjetas + "tarjeta?canal=WEB",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },

    };
    return await axios(config);
  }

  async pagar(nro, modo) {
    var data = JSON.stringify({
      numeroTarjeta: nro,
      modo: modo,
      canal: "WEB",

    });

    var config = {
      method: "post",
      url: tarjetas + "tarjeta/pagar",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    // console.log(data)
    return await axios(config);
  }

  async confirmarPago(tarjeta, cuenta, importe) {
    var data = JSON.stringify({
      canal: "WEB",
      cuentaDebito: cuenta,
      importeDebito: importe,
      numeroTarjeta: tarjeta,

    });

    var config = {
      method: "post",
      url: tarjetas + "tarjeta/pagar",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    //console.log(data)
    return await axios(config);
  }

  async descagarComponente(titulo, nroOperacion, nroSocioTitular, tarjeta, deuda, cuentaDebito, saldoCuentaDebito, totalPagado) {

    var _url = comprobantes + "comprobantes/v2/tarjetas-creditos";


    var data = JSON.stringify({
      titulo: titulo,
      nroOperacion: nroOperacion,
      nroSocioTitular: nroSocioTitular,
      tarjeta: tarjeta,
      deuda: deuda,
      cuentaDebito: cuentaDebito,
      saldoCuentaDebito: saldoCuentaDebito,
      totalPagado: totalPagado,
    });

    var config = {
      method: "post",
      url: _url,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);

  }

  async solicitarPrecalificado(datosPromo) {

    var _url = tarjetas + "tarjeta/solicitar-precalificado";

    var config = {
      method: "post",
      url: _url,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: datosPromo,
    };
    return await axios(config);

  }

  //** SERVICIOS DE CABAL */
  async getInfoTarjeta() {

    var _url = dimo + "dimoTarjetas/getInfoTarjeta";

    var config = {
      method: "post",
      url: _url,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: { canal: "WEB" },
    };
    return await axios(config);

  }

  async bloqueoDesbloqueoTarjeta(data) {

    data = { ...data, canal: "WEB" }

    var _url = dimo + "dimoTarjetas/bloqueoDesbloqueoTC";

    var config = {
      method: "post",
      url: _url,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data,
    };
    return await axios(config);
  }

  async cambioDePin(numeroTarjeta, pinTarjeta) {

    let buffer = null;
    buffer = Buffer.from(pinTarjeta, "utf-8");
    pinTarjeta = buffer.toString("base64");

    let data = { numeroTarjeta, pinTarjeta, canal: "WEB" }

    var _url = dimo + "dimoTarjetas/modificacionPin";

    var config = {
      method: "post",
      url: _url,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data,
    };

    return await axios(config);

  }
  //** */

}

export default new TarjetaService();